import React from "react";
import { Box, Typography, useTheme } from "@material-ui/core";
import { NavigateNext } from "@material-ui/icons";
import { Link } from "react-router-dom";
import { Header, HeaderContainer, Heading, StyledBreadcrumb } from "./styles";
var HeaderWrapper = function (_a) {
    var heading = _a.heading, breadcrumb = _a.breadcrumb, _b = _a.breadcrumbSeparator, breadcrumbSeparator = _b === void 0 ? null : _b, actions = _a.actions, customHeaderStyle = _a.customHeaderStyle, customActionStyle = _a.customActionStyle;
    var theme = useTheme();
    var activeBreadCrumbStyle = {
        color: theme.palette.text.primary,
        fontSize: "13px",
        margin: 0
    };
    return (React.createElement(HeaderContainer, { style: customHeaderStyle },
        React.createElement(Header, null,
            React.createElement(Heading, null, heading),
            !!(breadcrumb === null || breadcrumb === void 0 ? void 0 : breadcrumb.length) && (React.createElement(StyledBreadcrumb, { style: { marginTop: "13px", paddingRight: "4px" }, className: "breadcrumb-container", separator: breadcrumbSeparator !== null && breadcrumbSeparator !== void 0 ? breadcrumbSeparator : React.createElement(NavigateNext, { fontSize: "small" }) }, breadcrumb.map(function (_a, index) {
                var link = _a.link, title = _a.title, onClick = _a.onClick;
                var isLastBreadCrumb = breadcrumb.length > 1 && index === breadcrumb.length - 1;
                var text = (React.createElement(Typography, { color: "secondary", style: isLastBreadCrumb
                        ? activeBreadCrumbStyle
                        : {
                            margin: 0,
                            color: theme.palette.text.secondary
                        }, onClick: onClick, key: "breadcrumb_".concat(index) }, title));
                return link ? (React.createElement(Link, { key: "breadcrumb_".concat(index), style: { textDecoration: "none" }, to: link }, text)) : (text);
            })))),
        actions && React.createElement(Box, { style: customActionStyle }, actions)));
};
export default HeaderWrapper;
//# sourceMappingURL=HeaderContainer.js.map